import '@/i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from '@/App';
import store from '@/store/Store';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://74a21c2f4c8f12c62614cc6bbc63d52f@o4510482329370624.ingest.de.sentry.io/4510482331336784',
  sendDefaultPii: true,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
